import React from "react";
import { Modal } from "react-bootstrap";
import "../../../css/ConfirmationModal.css";


const RelatedQualificationModal = ({ show, onCancel, onProceed, message }) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      keyboard={false}
      className="related-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fs14">Confirmation</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0 confirmtext">
          {message?.includes("Equivalent Qualification") ? (
            <>
              You do not have the exact required qualification. Your
              qualification has been considered as an{" "}
              <strong>Equivalent Qualification</strong>.
            </>
          ) : (
            <>
              You do not have the exact required qualification. Your
              qualification has been considered under{" "}
              <strong>Other Related Fields</strong>.
            </>
          )}
        </p>

        <p className="mt-3 mb-0 subconfirm">Do you want to continue?</p>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-outline-secondary cancelbutton" onClick={onCancel}>
          Cancel
        </button>

        <button className="btn btn-bob-orange" onClick={onProceed}>
          Proceed
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RelatedQualificationModal;
